/**
 * Recursos humanos (WALLIYO-0131), em português. A faithful translation of hr.en.ts,
 * which is the source text.
 */
export const hrPt = {
  "hr.tabs.aria": "Recursos humanos",
  "hr.tab.directory": "Diretório",
  "hr.tab.recruiting": "Recrutamento",
  "hr.tab.employees": "Funcionários",
  "hr.tab.learning": "Formação",
  "hr.subTabs.aria": "Funcionários",
  "hr.sub.records": "Processos",
  "hr.sub.joining": "Entradas",
  "hr.sub.timeOff": "Férias de todos",
  "hr.sub.performance": "Desempenho",
  "hr.sub.payroll": "Salários",
  "hr.sub.reviews": "Revisões",
  "hr.sub.leaving": "Saídas",
  "hr.locked": "Este separador é para os recursos humanos.",
  "hr.notBuilt": "Ainda não construído.",
  "hr.notBuiltHelp": "Este separador está desenhado e aguarda o seu ponto de acesso. Nada se perde.",
  "directory.title": "Diretório",
  "directory.sub": "Qualquer pessoa pode procurar qualquer pessoa.",
  "directory.search": "Encontrar alguém",
  "directory.searchHelp": "Um nome, ou o número do crachá.",
  "directory.searchPlaceholder": "Nome ou UUID",
  "directory.go": "Procurar",
  "directory.clear": "Ver toda a gente",
  "directory.loading": "A ler o diretório…",
  "directory.failed": "O diretório não pôde ser lido.",
  "directory.retry": "Tentar de novo",
  "directory.none": "Ninguém aqui corresponde a «{query}».",
  "directory.empty": "Ainda não há ninguém listado.",
  "directory.count": "{shown} de {total}",
  "directory.more": "Mais resultados do que os mostrados. Refine a procura.",
  "directory.colName": "Nome",
  "directory.colRoles": "Função",
  "directory.colTeams": "Equipas",
  "directory.colManager": "Responsável",
  "directory.open": "Abrir",
  "directory.noRole": "Ainda sem função",
  "directory.noTeam": "Ainda sem equipa",
  "directory.noManager": "Sem responsável",
  "directory.leads": "lidera-a",
  "directory.invited": "Convidado",
  "directory.back": "Voltar ao diretório",
  "directory.identity": "Quem é",
  "directory.uuid": "UUID",
  "directory.uuidHelp": "O número do crachá. Nunca muda.",
  "directory.email": "E-mail",
  "directory.managerOn": "{name}, {team}",
  "directory.teammates": "Todos nas suas equipas",
  "directory.whereTheySit": "Onde esta pessoa se situa",
  "directory.emailThem": "Enviar um e-mail",
  "directory.teammatesNone": "É a única pessoa nas suas equipas.",
  "directory.personFailed": "Esta pessoa não pôde ser lida.",
  "directory.viewOnly": "O diretório mostra apenas a estrutura. O que alguém pode fazer está em Funcionários.",
  "hr.loading": "A ler…",
  "hr.failed": "Não foi possível ler isso.",
  "hr.retry": "Tentar de novo",
  "joining.invite": "Convidar alguém",
  "joining.invited.title": "Convites em aberto",
  "joining.invited.help": "Já têm um UUID e não podem entrar enquanto não definirem uma palavra-passe.",
  "joining.invited.none": "Não há ninguém à espera de chegar.",
  "joining.arrived.title": "Chegaram recentemente",
  "joining.arrived.help": "Todos os que entraram nos últimos 30 dias.",
  "joining.arrived.none": "Ninguém entrou nos últimos 30 dias.",
  "joining.col.name": "Nome",
  "joining.col.roles": "Função",
  "joining.col.sent": "Convidado a",
  "joining.col.waiting": "À espera há",
  "joining.col.joined": "Entrou a",
  "joining.today": "Hoje",
  "joining.waiting": "{days} dias",
  "joining.stale": "Vale um lembrete",

  // ── Leaving ──
  "leaving.who": "Quem está a sair",
  "leaving.whoHelp": "Todos os que ainda estão cá, e os que já saíram.",
  "leaving.pick": "Escolher alguém",
  "leaving.alreadyLeft": "já saiu",
  "leaving.nobody": "Escolha alguém para ver o que uma saída deixaria para trás.",
  "leaving.gone": "{name} já saiu. Ficaram estas pontas soltas.",
  "leaving.noReason": "Nenhum motivo dado",
  "leaving.teams.title": "Equipas que lidera",
  "leaving.teams.help":
    "Numa equipa sem líder ninguém aprova férias, ninguém revê ninguém e ninguém atesta acessos — é o mesmo facto.",
  "leaving.teams.none": "Não lidera nenhuma equipa.",
  "leaving.teams.col.team": "Equipa",
  "leaving.teams.col.others": "Outras pessoas",
  "leaving.teams.col.after": "Depois de sair",
  "leaving.team.others": "{count} outras",
  "leaving.team.noLead": "Ninguém a lideraria",
  "leaving.team.covered": "Outra pessoa lidera-a",
  "leaving.team.handOver": "Passar a outrem",
  "leaving.grants.title": "Atribuído em nome próprio",
  "leaving.grants.help":
    "Retirar uma função nunca mexe nisto. Uma atribuição sem data de fim é como alguém que saiu continua com uma permissão.",
  "leaving.grants.none": "Nada lhe foi atribuído em nome próprio.",
  "leaving.grants.col.what": "O quê",
  "leaving.grants.col.why": "Porquê",
  "leaving.grants.col.ends": "Termina",
  "leaving.grant.forever": "Nunca termina",
  "leaving.grant.until": "Até",
  "leaving.grants.revoke": "Retirar estes",
  "leaving.last.title": "O último passo",
  "leaving.last.help":
    "Desativar termina as suas {sessions} sessões abertas e impede-o de entrar. Nada do que fez é removido — a auditoria nomeia-o para sempre — e continua listado nas suas equipas, para que ninguém fique discretamente com menos uma pessoa.",
  "leaving.last.deactivate": "Desativar",
  "leaving.last.seeThem": "Ver no diretório",

  // ── Records ──
  "records.find": "Procurar",
  "records.findPlaceholder": "Nome ou e-mail",
  "records.team": "Equipa",
  "records.role": "Função",
  "records.any": "Todos",
  "records.dueReview": "{count} acessos a rever",
  "records.accessDueReview": "acesso a rever",
  "records.none": "Ninguém corresponde.",
  "records.neverSeen": "Nunca entrou",
  "records.col.person": "Pessoa",
  "records.col.role": "Função",
  "records.col.teams": "Equipas",
  "records.col.joined": "Entrou a",
  "records.col.lastSeen": "Visto pela última vez",

  // ── Time off ──
  "timeOff.ask": "Pedir férias",
  "timeOff.approve": "Aprovar",
  "timeOff.refuse": "Recusar",
  "timeOff.days": "{days} dias",
  "timeOff.decidedBy": "Decidido por {name}",
  "timeOff.col.who": "Quem",
  "timeOff.col.kind": "Tipo",
  "timeOff.col.when": "Quando",
  "timeOff.col.days": "Dias",
  "timeOff.col.status": "Estado",
  "timeOff.kind.annual": "Férias anuais",
  "timeOff.kind.sick": "Baixa médica",
  "timeOff.kind.unpaid": "Sem vencimento",
  "timeOff.kind.parental": "Licença parental",
  "timeOff.kind.other": "Outro",
  "timeOff.status.pending": "À espera",
  "timeOff.status.approved": "Aprovado",
  "timeOff.status.refused": "Recusado",
  "timeOff.status.withdrawn": "Retirado",
  "timeOff.balance.title": "O seu saldo",
  "timeOff.balance.none":
    "Ainda ninguém definiu o seu direito. Os recursos humanos fazem-no no seu processo de emprego.",
  "timeOff.balance.allowance": "Direito",
  "timeOff.balance.taken": "Gozado",
  "timeOff.balance.pending": "Pedido",
  "timeOff.balance.pendingHelp": "Não gozado, mas também não livre.",
  "timeOff.balance.left": "Restante",
  "timeOff.toDecide.title": "À espera de si",
  "timeOff.toDecide.help": "Lidera a equipa deles, por isso a decisão é sua. Estar nos recursos humanos não é o mesmo.",
  "timeOff.mine.title": "Os seus pedidos",
  "timeOff.mine.none": "Não pediu férias.",
  "timeOff.away.title": "Ausentes hoje",
  "timeOff.away.none": "Ninguém está ausente hoje.",
  "timeOff.everybody.title": "De toda a gente",
  "timeOff.everybody.help": "Vê isto porque está nos recursos humanos. Quem decide é o líder da equipa.",
  "timeOff.form.title": "Pedir férias",
  "timeOff.form.kind": "Tipo",
  "timeOff.form.from": "Primeiro dia",
  "timeOff.form.to": "Último dia",
  "timeOff.form.days": "Dias",
  "timeOff.form.daysHelp": "Quantos dias úteis isto cobre.",
  "timeOff.form.reason": "Motivo",
  "timeOff.form.submit": "Enviar o pedido",
  "timeOff.decide.title": "Decidir este pedido",
  "timeOff.decide.approveNote": "Diga porque aprova",
  "timeOff.decide.refuseNote": "Diga porque recusa",
  "timeOff.decide.submit": "Registar a decisão",
  "timeOff.done": "{days} dias pedidos. Quem lidera a sua equipa é que decide.",
  "timeOff.approvedDone": "As férias de {name} foram aprovadas.",
  "timeOff.refusedDone": "O pedido de {name} foi recusado.",

  // ── Reviews ──
  "reviews.grants.title": "Vale a pena ver agora",
  "reviews.grants.help":
    "Uma atribuição com data de fim retira-se sozinha. Estas são as que não o fazem, e as de quem já não está cá.",
  "reviews.grants.none": "Nada está atribuído em nome próprio sem data de fim.",
  "reviews.leads.title": "Líderes que devem rever as suas pessoas",
  "reviews.leads.help": "Quem lidera a equipa deles já sabemos — ninguém precisa que lhe digam quem revê quem.",
  "reviews.leads.none": "Ninguém nas equipas tem algo atribuído em nome próprio.",
  "reviews.col.who": "Quem",
  "reviews.col.what": "O quê",
  "reviews.col.why": "Porquê",
  "reviews.col.concern": "Problema",
  "reviews.col.lead": "Líder",
  "reviews.col.team": "Equipa",
  "reviews.col.people": "Pessoas",
  "reviews.col.neverEnding": "Sem fim",
  "reviews.concern.holderLeft": "Já saiu",
  "reviews.concern.neverEnds": "Nunca termina",
  "reviews.concern.neverUsed": "Nunca usado",
  "reviews.changedAt": "Alterado a {when}",
  "reviews.open": "Abrir as permissões",

  // ── Payroll ──
  "payroll.month": "Mês",
  "payroll.open": "Abrir um mês",
  "payroll.close": "Fechar o mês",
  "payroll.notOpen": "Este mês ainda não foi aberto.",
  "payroll.closedOn": "Fechado a {when} por {name}",
  "payroll.hold": "Reter",
  "payroll.release": "Libertar",
  "payroll.lines.title": "O que cada pessoa recebe",
  "payroll.lines.help":
    "Feito a partir dos processos de emprego tal como estavam quando o mês foi aberto. Um aumento posterior não muda o que está aqui.",
  "payroll.col.person": "Pessoa",
  "payroll.col.gross": "Bruto",
  "payroll.col.contributions": "Contribuições",
  "payroll.col.net": "Líquido",
  "payroll.col.status": "Estado",
  "payroll.status.ready": "Pronto",
  "payroll.status.held": "Retido",
  "payroll.status.paid": "Pago",
  "payroll.total.people": "Pessoas",
  "payroll.total.gross": "Bruto",
  "payroll.total.contributions": "Contribuições",
  "payroll.total.net": "Líquido",
  "payroll.missing.title": "Ninguém sabe o que estas pessoas ganham",
  "payroll.missing.help":
    "O processo de emprego não indica bruto, por isso um processamento não as pode pagar. Preencha antes do próximo mês.",
  "payroll.openForm.title": "Abrir um mês",
  "payroll.openForm.month": "Mês",
  "payroll.openForm.help":
    "Cada processo de emprego com um bruto recebe uma linha. As contribuições começam a zero: o que é retido depende de onde a pessoa está, e não cabe a este ecrã adivinhar.",
  "payroll.openForm.submit": "Abrir",
  "payroll.holdForm.title": "Alterar esta linha",
  "payroll.holdForm.hold": "Reter",
  "payroll.holdForm.release": "Libertar",
  "payroll.closeForm.title": "Fechar o mês",
  "payroll.closeForm.help": "Cada linha pronta passa a paga. Uma retida continua retida, que é para isso que serve.",
  "payroll.closeForm.submit": "Fechar",
  "payroll.opened": "{month} está aberto, com {count} linhas.",
  "payroll.held": "A linha de {name} está retida.",
  "payroll.released": "A linha de {name} será paga.",
  "payroll.closed": "O mês está fechado.",

  // ── Performance ──
  "performance.cycle": "Ciclo",
  "performance.openCycle": "Abrir um ciclo",
  "performance.noCycle": "Ainda não foi aberto nenhum ciclo.",
  "performance.runs": "De {from} a {to}",
  "performance.write": "Escrever",
  "performance.keepWriting": "Continuar",
  "performance.col.who": "Quem",
  "performance.col.reviewer": "Avaliador",
  "performance.col.status": "Estado",
  "performance.col.outcome": "Como correu",
  "performance.status.notStarted": "Não começou",
  "performance.status.inProgress": "A ser escrita",
  "performance.status.submitted": "Enviada",
  "performance.status.signedOff": "Validada",
  "performance.gap.noTeam": "Em nenhuma equipa",
  "performance.gap.noLead": "A equipa não tem líder",
  "performance.gap.leadsOwn": "Lidera a própria equipa",
  "performance.toWrite.title": "À espera de si",
  "performance.toWrite.help": "Lidera a equipa deles, por isso escreve-a.",
  "performance.mine.title": "A sua avaliação",
  "performance.mine.none": "Não tem avaliação neste ciclo.",
  "performance.everybody.title": "De toda a gente",
  "performance.everybody.help": "Vê isto porque está nos recursos humanos. Escrever cabe ao avaliador.",
  "performance.everybody.gaps":
    "{count} destas não têm quem as escreva. Isso é sobre a organização, não sobre este ciclo.",
  "performance.form.title": "Abrir um ciclo",
  "performance.form.name": "Nome",
  "performance.form.opens": "Primeiro dia",
  "performance.form.closes": "Último dia",
  "performance.form.submit": "Abrir",
  "performance.writeForm.title": "Escrever a avaliação",
  "performance.writeForm.outcome": "Como correu",
  "performance.writeForm.outcomeHelp": "Uma palavra que escolhe, não uma nota de cinco.",
  "performance.writeForm.note": "O que aconteceu",
  "performance.writeForm.save": "Guardar para depois",
  "performance.writeForm.send": "Enviar",
  "performance.opened": "{name} está aberto, com {count} avaliações.",
  "performance.saved": "Guardado. Ninguém o vê até enviar.",
  "performance.sent": "Enviado. {name} já o pode ver.",

  // ── Recruiting and Learning ──
  "recruiting.openJob": "Abrir uma vaga",
  "recruiting.editJob": "Editar",
  "recruiting.addCandidate": "Adicionar alguém",
  "recruiting.move": "Avançar",
  "recruiting.none": "Ainda não foi aberta nenhuma vaga.",
  "recruiting.noTeam": "Sem equipa",
  "recruiting.noCandidates": "Ainda ninguém se candidatou.",
  "recruiting.liveCandidates": "{count} em prova",
  "recruiting.col.candidate": "Candidato",
  "recruiting.col.reach": "Como contactar",
  "recruiting.col.stage": "Fase",
  "recruiting.col.applied": "Candidatura",
  "recruiting.stage.applied": "Candidatura",
  "recruiting.stage.screening": "Triagem",
  "recruiting.stage.interview": "Entrevista",
  "recruiting.stage.offer": "Proposta enviada",
  "recruiting.stage.hired": "Contratado",
  "recruiting.stage.declined": "Recusado",
  "recruiting.stage.withdrawn": "Desistiu",
  "recruiting.status.open": "Aberta",
  "recruiting.status.onHold": "Em pausa",
  "recruiting.status.filled": "Preenchida",
  "recruiting.status.closed": "Fechada",
  "recruiting.jobForm.title": "Abrir uma vaga",
  "recruiting.jobForm.name": "Título",
  "recruiting.jobForm.team": "Equipa",
  "recruiting.jobForm.noTeam": "Ainda sem equipa",
  "recruiting.jobForm.description": "Em que consiste",
  "recruiting.jobForm.status": "Estado",
  "recruiting.jobForm.submit": "Abrir",
  "recruiting.candidateForm.title": "Adicionar alguém",
  "recruiting.candidateForm.name": "Nome",
  "recruiting.candidateForm.phone": "Telefone",
  "recruiting.candidateForm.email": "E-mail",
  "recruiting.candidateForm.note": "O que vale a pena saber",
  "recruiting.candidateForm.submit": "Adicionar",
  "recruiting.moveForm.title": "Avançar",
  "recruiting.moveForm.stage": "Fase",
  "recruiting.moveForm.hired":
    "Marcar alguém como contratado regista que o foi. Convidá-lo faz-se em Entradas, onde já existe.",
  "recruiting.moveForm.submit": "Avançar",
  "recruiting.jobOpened": "{title} está aberta.",
  "recruiting.jobEdited": "{title} foi atualizada.",
  "recruiting.candidateAdded": "{name} está na lista.",
  "recruiting.candidateMoved": "{name} está agora em {stage}.",
  "learning.addCourse": "Adicionar uma formação",
  "learning.enrol": "Inscrever-se",
  "learning.continue": "Continuar",
  "learning.finish": "Concluir",
  "learning.alreadyEnrolled": "Inscrito",
  "learning.requiredBy": "Exigida por {permission} — concluir antes da atribuição, não depois.",
  "learning.requiredOfAll": "Obrigatória para todos",
  "learning.anybody": "Aberta a todos",
  "learning.minutes": "{minutes} min",
  "learning.enrolled": "{count} inscritos",
  "learning.hrOnly": "Só recursos humanos",
  "learning.mine.title": "Obrigatória para si",
  "learning.mine.help":
    "Uma formação ligada a uma permissão tem de estar concluída antes de a permissão ser atribuída.",
  "learning.mine.none": "Neste momento nada é obrigatório para si.",
  "learning.catalogue.title": "Catálogo",
  "learning.catalogue.help":
    "Aberto a todos. Inscrever-se não precisa da permissão de ninguém — precisa a atribuição por trás da formação.",
  "learning.byTeam.title": "Em toda a empresa",
  "learning.byTeam.help": "Quem ainda deve as formações obrigatórias. Quem insiste é o líder da equipa.",
  "learning.col.course": "Formação",
  "learning.col.status": "Estado",
  "learning.col.progress": "Progresso",
  "learning.col.team": "Equipa",
  "learning.col.people": "Pessoas",
  "learning.col.done": "Concluído",
  "learning.status.enrolled": "Inscrito",
  "learning.status.inProgress": "A decorrer",
  "learning.status.done": "Concluída",
  "learning.courseForm.title": "Adicionar uma formação",
  "learning.courseForm.name": "Título",
  "learning.courseForm.audience": "Para quem",
  "learning.courseForm.minutes": "Quanto tempo leva, em minutos",
  "learning.courseForm.required": "Exigida por uma permissão",
  "learning.courseForm.requiredHelp": "O id da definição da permissão de que esta formação é condição.",
  "learning.courseForm.everybody": "Obrigatória para todos",
  "learning.courseForm.submit": "Adicionar",
  "learning.courseAdded": "{title} está no catálogo.",
  "learning.enrolledDone": "Inscrito em {title}.",
  "learning.finished": "{title} está concluída.",

  // ── Alerts and refusals ──
  "alert.dismiss": "Fechar",
  "error.reason.permission_not_held":
    "A sua função abre este ecrã, mas não esta ação. Peça a alguém que a possa atribuir.",
  "error.reason.not_found": "Isto já não existe. Recarregue e tente de novo.",
  "error.reason.no_reason": "Diga porquê, em poucas palavras.",
  "error.reason.name_taken": "Esse nome já está ocupado.",
  "error.reason.team_closed": "Isto está fechado. Reabra antes de adicionar alguém.",
  "error.reason.staff_deactivated": "Esta pessoa saiu e não pode ser adicionada.",
  "error.reason.lead_must_be_member": "Só se lidera uma equipa de que se faz parte.",
  "error.reason.duplicate_change": "A mesma pessoa aparece duas vezes. Envie-a uma só vez.",
  "error.reason.own_request": "Não pode decidir as suas próprias férias.",
  "error.reason.not_their_lead":
    "Só quem lidera a equipa deles pode decidir. Estar nos recursos humanos não é o mesmo.",
  "error.reason.already_decided": "Isto já foi decidido. Recarregue para ver como.",
  "error.reason.backwards": "O último dia é anterior ao primeiro.",
  "error.reason.too_long": "Isso é mais longo do que um pedido pode cobrir.",
  "error.reason.month_open": "Esse mês já está aberto.",
  "error.reason.already_paid": "Esta linha foi paga. Um mês fechado é o que foi pago.",
  "error.reason.already_closed": "Este mês já está fechado.",
  "error.reason.nobody_payable": "Nenhum processo de emprego tem um bruto registado.",
  "error.reason.invalid_month": "Indique o mês como AAAA-MM.",
  "error.reason.own_review": "Não pode escrever a sua própria avaliação.",
  "error.reason.not_the_reviewer": "Foi pedido a outra pessoa que a escrevesse.",
  "error.reason.signed_off": "Esta avaliação foi validada.",
  "error.reason.no_outcome": "Diga como correu antes de enviar.",
  "error.reason.job_closed": "Esta vaga está fechada. Reabra antes de adicionar alguém.",
  "error.reason.candidate_out": "Esta pessoa já não está em prova. Adicione-a de novo se voltar.",
  "error.reason.title_taken": "Esse título já está ocupado.",
  "error.reason.course_retired": "Esta formação já não é dada.",
  "error.reason.invalid_progress": "O progresso é uma percentagem inteira, de 0 a 100.",

  // ── Roles: what a role covers ──
  "roles.covers.everything": "Tudo",
  "roles.covers.features": "{count} funcionalidades",
  "roles.covers.permissions": "{count} permissões",
  "roles.covers.critical": "{count} críticas",
  "roles.covers.high": "{count} altas",
  "roles.covers.seeAll": "Ver as {count}",
  "roles.covers.permissionsHeading": "Permissões",

  // ── Roles, redesigned ──
  "roles.band.critical": "funções podem decidir o que todos podem fazer",
  "roles.band.people": "pessoas têm uma delas",
  "roles.band.total": "funções no total",
  "roles.band.unheld": "ninguém tem",
  "roles.reach.critical": "Crítica",
  "roles.reach.high": "Alta",
  "roles.reach.low": "Baixa",
  "roles.rail.people": "{count} pessoas",
  "roles.rail.unheld": "ninguém a tem",
  "roles.noDescription": "Sem descrição",
  "roles.figure.people": "Pessoas",
  "roles.figure.features": "Funcionalidades",
  "roles.figure.permissions": "Permissões",
  "roles.figure.critical": "Críticas",
  "roles.block.holders": "Quem a tem",
  "roles.block.holdersHelp": "Dar esta função a alguém dá-lhe tudo o que está abaixo.",
  "roles.block.holdersNone": "Ninguém tem esta função.",
  "roles.block.give": "Dar a alguém",
  "roles.block.take": "Retirar",
  "roles.block.grants": "O que concede",
  "roles.block.grantsHelp": "Até onde chega, por área.",
  "roles.block.criticalWarning": "Quem tem esta função pode decidir o que todos os outros podem fazer.",
  "roles.block.change": "Alterar o que concede",
  "roles.block.opens": "O que abre",
  "roles.block.opensHelp": "Calculado a partir das funcionalidades acima, nunca guardado — o menu usa a mesma função.",
  "roles.block.opensNone": "Não abre nenhum ecrã por si só.",
  "roles.block.compare": "Comparada com",
  "roles.block.compareWith": "Comparar com",
  "roles.compare.only": "{count} só aqui",
  "roles.compare.theirs": "{count} só ali",
  "roles.compare.shared": "{count} em comum",
  "roles.give.title": "Dar esta função a alguém",
  "roles.give.who": "Quem",
  "roles.give.submit": "Dar",
  "roles.give.done": "{name} passa a ter {role}.",
  "roles.take.title": "Retirar esta função",
  "roles.take.body": "Mantém todas as outras funções.",
  "roles.take.submit": "Retirar",
  "roles.take.done": "{name} já não tem {role}.",
  "roles.holdersUnknown": "Não foi possível ler",
  "roles.compare.same": "Concedem exatamente as mesmas funcionalidades.",
  "roles.notice.critical": "{roles} destas podem decidir o que todos podem fazer — {people} pessoas têm uma.",
  "roles.notice.criticalOnly": "{roles} destas podem decidir o que todos podem fazer.",
  "roles.notice.unheld": "{count} não tem ninguém.",

  // ── Actions, by person ──
  "actions.find": "Encontrar alguém",
  "actions.matches": "Quem queria dizer?",
  "actions.findPlaceholder": "Nome ou UUID",
  "actions.nobody": "Procure alguém para ver o que pode fazer.",
  "actions.noRoles": "Sem função",
  "actions.col.on": "Ligado",
  "actions.col.source": "Origem",
  "actions.col.reason": "Motivo",
  "actions.mustAsk": "tem de pedir acima de {limit}",
  "actions.clear": "Limpar",
  "actions.until": "até {when}",
  "actions.onlyOverrides":
    "Só uma exceção está definida nesta pessoa, por isso é a única que este ecrã pode retirar. Tudo o resto vem de uma função ou de como a ação é entregue — altere-os onde vivem.",
  "actions.blocked.permission": "Tem a funcionalidade, não a permissão que esta ação exige.",
  "actions.locked.noFeature": "Aberta a todos: não há interruptor por trás.",
  "actions.view.catalogue": "O catálogo",
  "actions.view.person": "Por pessoa",
  "actions.notWiredYet": "Ligar ainda não está ligado. Use Funcionalidades e Permissões por agora.",
  "actions.view.role": "Por função",
  "actions.pickRole": "Função",

  // ── Switching an action ──
  "actions.switch.onTitle": "Ligar",
  "actions.switch.offTitle": "Desligar",
  "actions.switch.clearTitle": "Limpar",
  "actions.switch.submit": "Ligar",
  "actions.switch.writes": "Isto escreve a funcionalidade por trás: {feature}.",
  "actions.switch.alsoMoves": "Essa funcionalidade também abre {count} outras ações, que vão junto: {actions}.",
  "actions.switch.permissionToo": "Continuará a faltar a permissão que guarda esta ação. Atribua-a em Permissões.",
  "actions.switch.switchedOn": "{action} está ligada para {who}.",
  "actions.switch.switchedOff": "{action} está desligada para {who}.",
  "actions.switch.cleared": "{action} volta ao que herda.",
  "actions.pending": "ainda não guardado",
  "actions.saved": "{count} interruptores guardados.",
} as const;
